import { Star } from "lucide-react";
import { PROMO } from "@/lib/site";

const ITEMS = [
  "Veteran & Family-Owned",
  "Free Pickup & Delivery",
  `${PROMO.name} — Comforters $19.99`,
  "Chandler · Gilbert · Tempe · Ahwatukee · Sun Lakes · Maricopa",
  "Call 480-940-6023",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative z-20 -my-3 -rotate-1 overflow-hidden border-y-4 border-brand-navy bg-fall-amber py-3.5"
  >
    <div className="animate-marquee flex w-max whitespace-nowrap">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item, i) => (
            <span
              key={`${dup}-${i}`}
              className="flex items-center font-display text-sm font-extrabold uppercase tracking-[0.2em] text-brand-navy"
            >
              <span className="px-6">{item}</span>
              <Star className="h-4 w-4 fill-brand-navy" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
